import React, { Component } from 'react'
import { IconButton } from 'react-toolbox'
import CSSModules from 'react-css-modules'

import SpecItemComponent from './SpecItemComponent'
import RiskIcon from 'components/custom/RiskIcon/index'
import {
  FILTER_ALL,
  FILTER_RISK,
  FILTER_MODIFIED,
} from 'containers/Project/Specifications/constants'

import styles from './styles.scss'

class SpecItem extends Component {
  render() {
    const {
      label,
      risk,
      isModifiedPage,
      hideIcon,
      curFilter,
      curStatus,
    } = this.props
    let {
      initValue,
      modifiedValue,
    } = this.props

    let icon = null

    if (curStatus === FILTER_RISK) {
      icon = <RiskIcon />
    } else if (curStatus === FILTER_MODIFIED) {
      icon = <IconButton icon='mode_edit' theme={styles} />
    }

    return (
      <SpecItemComponent
        label={label}
        isModifiedPage={isModifiedPage}
        hideIcon={hideIcon}
        modifiedValue={modifiedValue}
        initValue={initValue}
        icon={icon}
      />
    )
  }
}

export default CSSModules(SpecItem, styles)
